import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthService from '../services/authService';
import NotificationService from '../services/notificationService';
import StoreService from '../services/storeService';

/**
 * Handles initial session check and redirects authenticated users
 * from / and /login to the appropriate destination (dashboard or registration).
 */
function AppInitializer({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const initialPath = location.pathname;
    const checkInitialSession = async () => {
      try {
        const isAuthenticated = await AuthService.isAuthenticated();
        if (isAuthenticated) {
          const userId = await AuthService.getCurrentUserId();
          localStorage.setItem('userId', userId);
          NotificationService.init().catch(() => {});

          if (initialPath === '/' || initialPath === '/login') {
            try {
              const progress = await StoreService.checkRegistrationProgress();
              if (progress.hasStore && progress.storeId) {
                localStorage.setItem('storeId', progress.storeId);
                if (!progress.hasLocation) {
                  const storeDetails = {
                    storeId: progress.storeId,
                    storeType: progress.store?.storeType || '',
                    phone: progress.store?.phone || '',
                    businessRegNo: progress.store?.bRegNo || '',
                    tinNumber: progress.store?.tinNo || '',
                    businessLicenseUrl: progress.store?.llcense || '',
                    activeHrs: progress.store?.activeHrs || ''
                  };
                  localStorage.setItem('storeRegistrationDetails', JSON.stringify(storeDetails));
                }
              }
              navigate(progress.nextStep, { replace: true });
            } catch {
              // Don't redirect on error - let user stay on current page
            }
          }
        } else {
          localStorage.removeItem('userId');
          localStorage.removeItem('storeId');
          localStorage.removeItem('storeRegistrationDetails');
          localStorage.removeItem('storeLocationDetails');
        }
      } catch {
        localStorage.removeItem('userId');
        localStorage.removeItem('storeId');
        localStorage.removeItem('storeRegistrationDetails');
        localStorage.removeItem('storeLocationDetails');
      }
    };

    checkInitialSession();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Run once on app mount only — initial redirect from / or /login

  return <>{children}</>;
}

export default AppInitializer;
